/**
 * PortalPagination
 *
 * This object handles pagination settings
 */

// the constructor for this object
function PortalPagination() {
    this.urlParams = {};
    this.urlParamKeys = {
        page: 'page',
        sort: 'sort',
        order: 'order',
        search: 'search',
    };
}

// the object
PortalPagination.prototype = {
    constructor: PortalPagination,

    // the selector for the pagination container
    paginationSelector: false,

    // the container of the data
    contentSelector: false,

    // the selector of the search field
    searchSelector: false,

    // the column to add to the submission data for a search field
    searchColumn: false,

    // the stored search value (from the url)
    searchValue: false,

    // the stored sort column value (from the url)
    sortColumnValue: false,

    // the stored sort order value (from the url)
    sortOrderValue: false,

    // this is the controller event that should be called after a pagination event
    eventCallback: false,

    // the amount of entries that should be shown per page
    perPage: 10,

    // the current page
    currentPage: 1,

    // the total number of pages
    totalPages: false,

    // the last event that occurred. this helps controllers know how to handle api results
    lastEvent: 'load',

    // the URL keys to find for the URL params (DEFINED IN CONSTRUCTOR)
    urlParamKeys: null,

    // the url parameters to be displayed (page, search, sort, order) (DEFINED IN CONSTRUCTOR)
    urlParams: null,

    // register the pagination events
    init: function()
    {
        // set the fields from the url params
        this._setFromUrlParams();

        this._setSearchField();
        this._showSorting();

        this._registerPageEvents();
        this._registerSortEvents();
        this._registerSearchEvents();
        this._registerShowMoreEvents();
    },

    // set the starting display from the url parameters
    _setFromUrlParams: function()
    {
        // set the current page
        var currentPage = parseInt(PortalHelper.getUrlParameter(this.urlParamKeys.page));
        if (currentPage && Number.isInteger(currentPage)) {
            this.currentPage = currentPage;
        }

        // set the sorting
        this.sortColumnValue = PortalHelper.getUrlParameter(this.urlParamKeys.sort);
        this.sortOrderValue = PortalHelper.getUrlParameter(this.urlParamKeys.order);

        // set the search field
        var searchValue = PortalHelper.getUrlParameter(this.urlParamKeys.search);
        if (searchValue) {
            this.searchValue = searchValue;
        }
    },

    // fill in the search field with data set from the url
    _setSearchField: function()
    {
        if (this.searchValue !== false && this.searchSelector !== false) {
            $('input[type="search"],input[type="text"]', this.searchSelector).val(this.searchValue);
        }
    },

    // handle the page changing events
    _registerPageEvents: function()
    {
        var self = this;

        // go to the first page
        $('.first-button', self.paginationSelector).on('click', function() {
            self.hidePagination();

            self.lastEvent = 'page';

            self.setPage(1);
            self.eventCallback();
        });

        // go to the previous page
        $('.previous-button', self.paginationSelector).on('click', function() {
            self.hidePagination();

            self.lastEvent = 'page';

            var previousPage = self.currentPage - 1;
            if (previousPage < 0) { previousPage = 1; }
            self.setPage(previousPage);
            self.eventCallback();
        });

        // go to the next page
        $('.next-button', self.paginationSelector).on('click', function() {
            self.hidePagination();

            self.lastEvent = 'page';

            var nextPage = self.currentPage + 1;
            if (nextPage > self.totalPages) {
                nextPage = self.totalPages;
            }
            self.setPage(nextPage);
            self.eventCallback();
        });

        // go to the last page
        $('.last-button', self.paginationSelector).on('click', function() {
            self.hidePagination();

            self.lastEvent = 'page';

            self.setPage(self.totalPages);
            self.eventCallback();
        });
    },

    // handle the column sorting events
    _registerSortEvents: function()
    {
        var self = this;

        // handle sorting events
        $('th.sortable-column', self.contentSelector).on('click', function() {
            var sortColumn = $(this).attr('data-sort-column');
            self._showSorting(sortColumn);

            self.hidePagination();

            self.lastEvent = 'sort';

            self._setSorting(sortColumn);
            self.setPage(1);
            self.eventCallback();
        });
    },

    // handle the search field events
    _registerSearchEvents: function()
    {
        var self = this;

        // handle the search event
        if (this.searchSelector !== false) {
            $(this.searchSelector).on('submit', function(e) {
                e.preventDefault();

                self.hidePagination();

                self.lastEvent = 'search';

                self._setSearch();
                self.setPage(1);
                self.eventCallback();
            });
        }
    },

    // handle the page changing events
    _registerShowMoreEvents: function()
    {
        var self = this;

        // go to the first page
        $('.show-more-button', self.paginationSelector).on('click', function(e) {
            e.preventDefault();

            // only fire if the link is not disabled
            if (!$(this).attr('disabled')) {
                self.lastEvent = 'more';

                self.currentPage++;
                self.eventCallback();
            }
            this.blur();
        });
    },

    // set the current page number in this object, and in the url
    setPage: function(pageNumber)
    {
        this.currentPage = pageNumber;
        if (pageNumber == 1) {
            pageNumber = null; // don't display page=1 in the url
        }
        this._setUrlParam('page', pageNumber);
    },

    // set the current page number in this object, and in the url
    _setSorting: function(sortColumn)
    {
        // check if the sort column is currently up
        var thCell = $('th.sortable-column[data-sort-column=' + sortColumn + ']', this.contentSelector);
        var sortedAsc =  $('.sortable', thCell).hasClass('sortable--sorted-up');
        var sortedDesc =  $('.sortable', thCell).hasClass('sortable--sorted-down');

        var order = null;
        if (sortedAsc) {
            order = 'asc';
        } else if (sortedDesc){
            order = 'desc';
        }

        if (order == null) {
            this._setUrlParam('sort', null);
            this._setUrlParam('order', order);
        } else {
            this._setUrlParam('sort', sortColumn);
            this._setUrlParam('order', order);
        }
    },

    // set the current page number in this object, and in the url
    _setSearch: function()
    {
        var searchValue = $('input', this.searchSelector).val();
        this._setUrlParam('search', searchValue);
    },

    // change the url parameters
    _setUrlParam: function(parameterKey, value)
    {
        // find the proper parameter by the key
        var parameter = this.urlParamKeys[parameterKey];

        // get all the actual params from the url
        var allUrlParams = PortalHelper.getAllUrlParameters();

        // add or remove the param from the object
        if (value) {
            this.urlParams[parameter] = value;
            allUrlParams[parameter] = value;
        } else if (this.urlParams.hasOwnProperty(parameter)) {
            delete this.urlParams[parameter];
            delete allUrlParams[parameter];
        }

        // build the url and replace the current history
        var paramString = '?' + $.param(allUrlParams);
        history.replaceState(null, null, paramString);
    },

    // get the submission data that is pertinent to the pagination
    getBaseSubmissionData: function(data)
    {
        // get the page data
        var submissionData = {
            perPage: this.perPage,
            page: this.currentPage // this does not impact the api. it only is used in prevention of duplicate requests
        }

        // set the search value if one exists
        if (this.searchSelector !== false) {
            var searchValue = $('input', this.searchSelector).val();
            if (searchValue) {
                submissionData[this.searchColumn] = searchValue;
            }
        }

        // aplly the sorting if applicable
        var sortedAsc =  $('th.sortable-column .sortable.sortable--sorted-up', this.contentSelector);
        if (sortedAsc.length > 0) {
            var sortColumn = sortedAsc.parent().attr('data-sort-column');
            submissionData.sort_column = sortColumn;
            submissionData.sort_order = 'asc';
        }
        var sortedDesc =  $('th.sortable-column .sortable.sortable--sorted-down', this.contentSelector);
        if (sortedDesc.length > 0) {
            var sortColumn = sortedDesc.parent().attr('data-sort-column');
            submissionData.sort_column = sortColumn;
            submissionData.sort_order = 'desc';
        }

        return submissionData;
    },

    // take api data and update the pagination stats
    updatePagination: function(data)
    {
        // store the total pages
        this.totalPages = data.last_page;

        if (this.totalPages == 0) {
            this.currentPage = 0;
        }

        // set the current page number
        $('#current-page', this.paginationSelector).html(this.currentPage);

        // set the total number of pages
        $('#total-pages', this.paginationSelector).html(this.totalPages);

        // hide the first, and previous page button if on the first page
        if (this.currentPage <= 1) {
            $('.first-button', this.paginationSelector).addClass('hidden');
            $('.previous-button', this.paginationSelector).addClass('hidden');
        } else {
            $('.first-button', this.paginationSelector).removeClass('hidden');
            $('.previous-button', this.paginationSelector).removeClass('hidden');
        }

        // hide the last, and next page button if on the first page
        if (this.currentPage == this.totalPages) {
            $('.last-button', this.paginationSelector).addClass('hidden');
            $('.next-button', this.paginationSelector).addClass('hidden');
        } else {
            $('.last-button', this.paginationSelector).removeClass('hidden');
            $('.next-button', this.paginationSelector).removeClass('hidden');
        }

        // hide the show more button if on the last page
        if (this.currentPage == this.totalPages) {
            $('.show-more-button', this.paginationSelector).attr('disabled', true);
        } else {
            $('.show-more-button', this.paginationSelector).attr('disabled', false);
        }
    },

    hidePagination: function()
    {
        PortalHelper.loadingOverlay(this.contentSelector, true);
        PortalHelper.loadingOverlay(this.paginationSelector, true);
    },

    showPagination: function()
    {
        PortalHelper.loadingOverlay(this.contentSelector, false);
        PortalHelper.loadingOverlay(this.paginationSelector, false);
    },


    // change the visual display for the sorting column
    _showSorting: function(sortColumn = null, order = null)
    {
        // set the override sort order only on load
        if (!sortColumn && this.sortOrderValue != null) {
            order = this.sortOrderValue;
        }

        // if no sort column was provided, and one was set through the url, this is the initial load
        if (!sortColumn && this.sortColumnValue != null) {
            sortColumn = this.sortColumnValue;
        }

        if (sortColumn) {
            var thCell = $('th.sortable-column[data-sort-column=' + sortColumn + ']', this.contentSelector);

            // check if the sort column is currently up
            var sortedAsc =  $('.sortable', thCell).hasClass('sortable--sorted-up');
            var sortedDesc =  $('.sortable', thCell).hasClass('sortable--sorted-down');

            // unset all the sorting columns
            $('th.sortable-column .sortable', this.contentSelector).removeClass('sortable--sorted-up sortable--sorted-down');

            // apply the sorting
            if (sortedAsc) {
                $('.sortable', thCell).addClass('sortable--sorted-down');
            } else if (sortedDesc){
                // nothing, the sort is reset
            } else {
                $('.sortable', thCell).addClass('sortable--sorted-up');
            }

            // clear the sorting if a specific order is selected
            if (order != null) {
                $('th.sortable-column .sortable', this.contentSelector).removeClass('sortable--sorted-up sortable--sorted-down');
            }
            // apply the override sort order
            if (order == 'asc') {
                $('.sortable', thCell).addClass('sortable--sorted-up');
            } else if (order == 'desc') {
                $('.sortable', thCell).addClass('sortable--sorted-down');
            }
        }

    },

}
